import { EntidadeBase } from 'hay-core-react';
class ModalidadeModel extends EntidadeBase {
    constructor() { super('modalidade'); }
}

const instance = new ModalidadeModel();
export default instance;
